import styled from "styled-components"
import DataTable_s from "components/table/data-table-styles"
import { Colors } from "styles/app-styles"

export const DepartmentalLineItems_s = styled.div`
  .p-paginator {
    bottom: 0px;
  }
`

export const DepartmentalLineItemsTable_s = styled(DataTable_s)`
  border-spacing: 15px;

  .p-datatable-scrollable-view.p-datatable-frozen-view .p-datatable-scrollable-header-table {
    width: 405px;
  }

  table.p-datatable-scrollable-header-table, table.p-datatable-scrollable-body-table {
    width: auto;
  }

  .p-datatable-thead > tr {
    height: 30px;
  }

  .p-datatable-scrollable-body {
    padding-bottom: 200px;
  }

  // Hide filter input row
  .p-datatable-unfrozen-view thead.p-datatable-thead > tr:last-child {
    display: none;
  }

  .immutable {
    background: ${Colors.athensGrey} !important;
  }

  .systemImmutable-row td:not(.system-immutable-editable) {
    background: ${Colors.athensGrey} !important;
  }

  .system-row .system-disabled {
    background: ${Colors.athensGrey};
  }

  .systemImmutable-row, .system-row .system-disabled {
    input.p-inputtext:not(.has-errors) {
      background: inherit;
      border: none !important;
    }
  }
`

export const PercentTenantRevenue_s = styled.div`
  .p-dropdown {
    width: 285px;
  }
`
